import { supabase } from "@/integrations/supabase/client";

export async function reverseStockForDocument(
  documentTable: "sale_documents" | "purchase_documents",
  itemsTable: "sale_document_items" | "purchase_document_items",
  documentId: string,
  transactionType: "deletion" | "cancellation"
) {
  try {
    const { error } = await supabase.rpc("reverse_document_stock", {
      p_document_table: documentTable,
      p_items_table: itemsTable,
      p_document_id: documentId,
      p_transaction_type: transactionType,
    });
    if (error) {
      console.error("[reverseStockForDocument] RPC error:", error);
      throw new Error(`Stock reversal failed: ${error.message}`);
    }
  } catch (err) {
    console.error("[reverseStockForDocument] Error:", err);
    throw err;
  }
}
